import GLPosts from './GLPosts'
export default GLPosts
